(() => {
  const labels = {
    'Expédition': 'Livraison',
    'Cueillette au magasin': 'Retrait'
  };

  const updateDeliveryWidget = () => {
    document.querySelectorAll('.identixweb-order-delivery').forEach((widget) => {
      widget.querySelectorAll('.identixweb-btn-icon').forEach((button) => {
        const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
        let textNode = walker.nextNode();

        while (textNode) {
          const currentLabel = textNode.nodeValue.trim();
          if (labels[currentLabel]) textNode.nodeValue = textNode.nodeValue.replace(currentLabel, labels[currentLabel]);
          textNode = walker.nextNode();
        }
      });

      widget.querySelectorAll('.shipping-identixweb-order-delivery-date').forEach((button) => {
        button.setAttribute('aria-label', 'Livraison');
      });

      widget.querySelectorAll('.store-pickup-identixweb-order-delivery-date').forEach((button) => {
        button.setAttribute('aria-label', 'Retrait en boutique');
      });
    });
  };

  let queued = false;
  const queueUpdate = () => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(() => {
      queued = false;
      updateDeliveryWidget();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueUpdate, { once: true });
  } else {
    queueUpdate();
  }

  new MutationObserver(queueUpdate).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
